/**
 * @file TaskAssigneeField.tsx
 * @description Поле «Исполнитель» формы новой задачи, звонка, встречи
 * (phase19.31, crm.md T1–T2): сотрудники магазина с правом CRM из
 * `task-assignees`, по умолчанию — текущий сотрудник (он первым в списке).
 * Пока список не пришёл — поле недоступно; не пришёл совсем — сервер
 * назначит автора, форма работает.
 */

import { useEffect } from "react";

import { Label } from "../../ui/label";
import { SelectField } from "../../ui/SelectField";
import { useTaskAssignees } from "./useTaskAssignees";

interface Props {
  value: string;
  onChange: (userId: string) => void;
  error?: string | null;
}

export function TaskAssigneeField({ value, onChange, error }: Props) {
  const { assignees, options, loading, failed } = useTaskAssignees();

  // По умолчанию — текущий сотрудник (T1), как только список пришёл.
  useEffect(() => {
    if (value) return;
    const me = assignees.find((a) => a.isMe) ?? assignees[0];
    if (me) onChange(me.id);
  }, [assignees, value, onChange]);

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor="activity-assignee">Исполнитель</Label>
      <SelectField
        id="activity-assignee"
        ariaLabel="Исполнитель"
        value={value}
        onChange={onChange}
        options={options}
        placeholder={loading ? "Загрузка…" : failed ? "Вы (список сотрудников не загрузился)" : "Выберите сотрудника"}
        disabled={loading || failed}
      />
      {error ? (
        <p id="activity-assignee-error" className="type-caption text-[var(--status-error-fg)]">
          {error}
        </p>
      ) : null}
    </div>
  );
}
